export const SET_ENTERTAINMENT = 'SET_ENTERTAINMENT';
export const GET_ENTERTAINMENT = 'GET_ENTERTAINMENT';
